module.exports = __webpack_public_path__ + "static/img/emptyType.2aa24b35.png";